export class UserAlertsError extends Error {}
